<template>
    <div class="mall-pay-result">
        <div class="result-container">
            <div class="result-top">
                <div class="result-icon"></div>
                <div class="result-text">
                    <div class="main-text">您已成功付款</div>
                    <div class="sub-text">仓库正在为您加急备货中...</div>
                </div>
            </div>
            <div v-if="orderInfo" class="result-info">
                <div class="info-container">
                    <div class="pay-money">
                        <div class="pay-label">实付金额:</div>
                        <div class="pay-value">¥{{ total_price }}</div>
                    </div>
                    <!-- <div class="info-item">
                        <div class="info-label">支付方式:</div>
                        <div class="info-value">支付宝支付</div>
                    </div> -->
                    <div class="info-item">
                        <div class="info-label">收件信息:</div>
                        <div class="info-value">{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.zone}}{{orderInfo.address}}  {{orderInfo.contact_person}}  {{orderInfo.contact_mobile}}</div>
                    </div>
                </div>
            </div>
            <div class="btn-box">
                <div class="btn-item" @click="$router.push({name:'MallOrderCenter'})">查看订单</div>
                <div class="btn-item" @click="$router.push({name:'Mall'})">继续购物</div>
            </div>
        </div>
    </div>
</template>
<script> 
 import {
        GetPayResult,
    } from "@/api/index.js"
export default{
    data(){
        return{
            list:[]
        }
    },
     computed:{
        orderInfo(){
           if(this.list.length >0) {
                return this.list[0].relate
           } else {
                return null
           }
        },
        total_price() {
            return this.list.reduce((sum, item) => {
                return Number(sum) + Number(item.money);
            }, 0);
        },
    },
    mounted(){
        this.uuid = this.$route.query.uuid
        if(this.$route.query.uuid) {
            GetPayResult({
                uuid: this.$route.query.uuid
            }).then(response => {
                this.list = response.data
            })
        }
    },
    methods:{}
}
</script>
<style lang="scss" scoped>
.mall-pay-result{
    width: 100%;
    min-height:100vh;
    background:rgb(246,247,250);
    display:flex;
    justify-content:center;
    .result-container{
        width:1560px;
        height:820px;
        background:#ffffff;
        border-radius:10px;
        margin-top:30px;
        padding:0 70px;
        display:flex;
        flex-direction:column;
        align-items:center;
        .result-top{
            width:100%;
            padding:80px 0 60px 0;
            border-bottom:1px solid #dbdbdb;
            display:flex;
            align-items:center;
            column-gap:18px;
            justify-content:center;
            .result-icon{
                width:56px;
                height:57px;
                background:url('../../assets/images/pay-success.png') no-repeat;
                background-size:cover;
                background-repeat:no-repeat;
                background-position: center;
            }
            .result-text{
                display:flex;
                flex-direction:column;
                .main-text{
                    color:#1a1a1a;
                    font-size:26px;
                    font-weight:bold;
                }
                .sub-text{
                    color:#4d4d4d;
                    font-size:16px;
                }
            }
        }
        .result-info{
            width:900px;
            background:#f7f7f7;
            margin-top:50px;
            .info-container{
                padding:30px 45px;
                display:flex;
                flex-direction:column;
                .pay-money{
                    display:flex;
                    align-items:baseline;
                    column-gap:8px;
                    font-weight:bold;
                    .pay-label{
                        color:#1a1a1a;
                        font-size:14px;
                    }
                    .pay-value{
                        color:#fa3d5a;
                        font-size:24px;
                    }
                }
                .info-item{
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    color:#4d4d4d;
                    font-size:14px;
                    line-height:26px;
                    .info-label{}
                    .info-value{
                        display:-webkit-box;
                        -webkit-box-orient:vertical;
                        -webkit-line-clamp:2;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        word-wrap:break-word;
                        word-break:break-all;
                    }
                }
            }
        }
        .btn-box{
            display:flex;
            justify-content:center;
            column-gap:20px;
            margin-top:64px;
            .btn-item{
                width:121px;
                height:43px;
                line-height:43px;
                text-align:center;
                border-radius:5px;
                border:1px solid #fa3d5a;
                color:#fa3d5a;
                background:#ffffff;
                cursor: pointer;
                &:last-child{
                    background:#fa3d5a;
                    color:#ffffff;
                }
            }
        }
    }
}
</style>